;(function( $ ){

	$.fn.select_by_value = function(value) {
		if($(this).prop('tagName').toLowerCase() === 'select') {
			$(this).find('option').each(function(index) {
        console.log($(this).attr('value'), value, $(this).attr('value') === value);
        if ( value === undefined ) {
          if ( $(this).attr('value') === undefined ) {
            $(this).prop('selected', true);
          }
        }
        else {
          if( $(this).attr('value') === String ( value ) ) {
            $(this).prop('selected', true);
          }
        }
			});
		}
		else {
			console.log('this function can only be applied to select controls');
		}

		return this;
	};

  $.fn.multi_select_by_values = function(values) {
		if($(this).prop('tagName').toLowerCase() === 'select') {
			$(this).find('option').each(function(index) {
				if(values.indexOf($(this).attr('value')) !== -1) {
					$(this).prop('selected', true);
        }
			});
		}
		else {
			console.log('this function can only be applied to select controls');
		}

		return this;
	};

	$.fn.sortOptions = function() {
		if($(this).prop('tagName').toLowerCase() === 'select') {
			var i, availableOptionsArr = [];
			$(this).find('option').each ( function ( index, elem ) {
				availableOptionsArr.push([
					$(elem).val(),
					$(elem).text()
				]);
			});

			availableOptionsArr.sort ( function ( a, b ) {
				if ( a[1] == b[1] ) {
					return 0;
				}
				return ( a[1] < b[1] ) ? -1 : 1;
			});

			$(this).empty();

			for ( i = 0; i < availableOptionsArr.length; i++ ) {
				$(this).append (
					$('<option></option>')
					  .attr ( 'value', availableOptionsArr[i][0] )
						.text ( availableOptionsArr[i][1] )
				);
			}
		}
		else {
			console.log('this function can only be applied to select controls');
		}

		return this;
	};

	$.fn.preload = function() {
    this.each(function(){
        $('<img/>')[0].src = this;
    });
	};
	// - USAGE : $(['img1.jpg','img2.jpg','img3.jpg']).preload();

  $.fn.outerHtml = function() {
    return $('<div>').append($(this).clone()).html();
  };

  // - CHANGE CLASS, CHANGES A SINGLE CLASS TO ANOTHER ONE
  // - PARAM ONE - CLASS TO REPLACE
  // - PARAM TWO - CLASS REPLACING WITH
  $.fn.switchClass = function ( replaceClass, withClass ) {
    $(this).removeClass ( replaceClass )
           .addClass ( withClass );
  };

  $.fn.clickToggle = function(a,b){
    return this.each(function(){
      var clicked = false;
      $(this).bind("click",function(){
        if (clicked) {
          clicked = false;
          return b.apply(this,arguments);
        }
        clicked = true;
        return a.apply(this,arguments);
      });
    });
};

  $.fn.hint = function() {
    $(this).clickToggle(
      function() {
        // console.log($(this).attr('title'));
        $(this).append (
          $('<div></div>')
            .addClass ( 'input-hint-text' )
            .text ( $(this).attr('title') )
        );
      },
      function() {
        // console.log('off');
        $(this).find('div.input-hint-text').remove();
      }
    );
  };

  $.fn.dragger = function ( target, host, targetsSelector, _options ) {
    var options = {
      threshold : 0.5,// - FACTOR OF HOW MUCH BOUNDING BOX CROSS OVER IN EACH DIMENSION THERE SHOULD BE TO SNAP IT IN.
      onPlaced : function(){},
    };

    if ( _options !== undefined ) {
      if ( _options.threshold !== undefined ) {
        options.threshold = _options.threshold;
      }

      if ( _options.onPlaced !== undefined ) {
        options.onPlaced = _options.onPlaced;
      }

      if ( _options.resetDragger !== undefined ) {
        options.resetDragger = _options.resetDragger;
      }
    }

    $(this)
      .off ( 'mousedown.drag' )
      .on  ( 'mousedown.drag', function ( evt ) {
        var dragger = $(this),
            xClickOffset = evt.offsetX,
            yClickOffset = evt.offsetY;
            // console.log(evt, evt.offsetX, evt.offsetY);

        host
          .off ( 'mousemove.drag' )
          .on  ( 'mousemove.drag', function ( evt ) {
            dragger.css ( 'left', evt.clientX - host.offset().left - xClickOffset );
            dragger.css ( 'top', evt.clientY - host.offset().top - yClickOffset );
          });

        host
          .off ( 'mouseup.drag' )
          .on  ( 'mouseup.drag', function ( evt ) {
            var resetPosition = true;

            $(targetsSelector).each ( function ( index, elem ) {
              console.log('---bounding boxes start---');
              console.log(index);
              console.log('target', $(elem)[0].getBoundingClientRect());
              console.log('dragger',dragger[0].getBoundingClientRect());
              console.log('---bounding boxes end---');
              var tBB = $(elem)[0].getBoundingClientRect();
              var dBB = dragger[0].getBoundingClientRect();

              // - CHECK X'S AND Y'S ARE WITHIN THRESHOLD
              var xIn = Math.abs ( tBB.left - dBB.left ) < ( tBB.width * options.threshold ),
                  yIn = Math.abs ( tBB.top - dBB.top ) < ( tBB.height * options.threshold );


              if ( xIn && yIn ) {
                resetPosition = false;
                dragger.css('top', tBB.top - host.offset().top);
                dragger.css('left', tBB.left - host.offset().left);

                options.onPlaced ( dragger, $(elem) );

                return false;
              }
            });

            if ( resetPosition ) {
              options.resetDragger ( dragger );
            }

            host.off ( 'mousemove.drag' );
            host.off ( 'mouseup.drag' );
          });
      });
  };

  // - HAS ATTRIBUTE
  $.fn.hasAttr = function ( attrName ) {
    return $(this)[0].hasAttribute ( attrName );
	};

})( jQuery );
